import { render, staticRenderFns } from "./ResetPasswordMail.vue?vue&type=template&id=2931cef2&scoped=true"
import script from "./ResetPasswordMail.vue?vue&type=script&lang=js"
export * from "./ResetPasswordMail.vue?vue&type=script&lang=js"
import style0 from "./ResetPasswordMail.vue?vue&type=style&index=0&id=2931cef2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2931cef2",
  null
  
)

export default component.exports